import {ReactComponent as Amount} from './icon/amount.svg';
import {ReactComponent as Coin} from './icon/coin.svg';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    "@global": {
        "@keyframes sizemobile": {
            "0%": {
                fontSize: 70
            },
            "50%": {
              fontSize: 68
            },
            "100%": {
              fontSize: 70
            }
          },
          "@keyframes coinmobile": {
            "0%": {
                top: '43%',
            },
            "50%": {
                top: '45%',
            },
            "100%": {
                top: '43%',
            }
          }
    },
    root: {
        height: '75%', 
        width: 'calc(100% - 15px)', 
        margin: '0 auto', 
        display: 'flex', 
        padding: '0 15px',
        flexDirection: 'column',
        paddingTop: 300,
    },
    to: {
        fontFamily: 'Montserrat, sans-serif',
        fontStyle: 'normal',
        fontWeight: 800,
        fontSize: 24,
        color: '#FFFFFF',
        paddingLeft: 15,
        position: 'relative',
        zIndex: 2,
        paddingBottom: 20
    },
    amount: {
        position: 'relative',
        fontFamily: 'Montserrat, sans-serif',
        fontStyle: 'normal',
        fontWeight: 900,
        fontSize: '75px',
        letterSpacing: '-0.035em',
        textTransform: 'uppercase',
        color: '#FFFFFF',
        textShadow: '-4px 6px 23px #07092F',
        transform: 'rotate(-3.49deg)',
        lineHeight: '50px',
        'animation-iteration-count': 'infinite',
        animationDuration: '1s',
        animationDirection: 'alternate',
        animationName: 'sizemobile',
    },
    amountText: {
        position: 'relative',
        zIndex: 2
    },
    amountIcon: {
        position: 'absolute', 
        top: -310, 
        left: -10, 
        zIndex: 1
    },
    firstDeposit: {
        fontFamily: 'Montserrat, sans-serif',
        fontStyle: 'normal',
        fontWeight: 800,
        fontSize: 28,
        color: '#FFFFFF',
        lineHeight: '98.4%',
        paddingTop: 15,
        paddingLeft: 15,
        paddingBottom: 30,
        position: 'relative',
        zIndex: 2
    },
    pl100: {
        paddingLeft: 0
    },
    wrapBtn: {
        width: 'calc(100% - 15px)', 
        background: '#FF005C', 
        padding: '16px 0',
        boxShadow: '-4px 6px 23px rgba(0, 0, 0, 0.41), 7px -10px 21px -11px rgba(255, 0, 92, 0.31)',
        backdropFilter: 'blur(61px)',
        borderRadius: 11,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        fontFamily: 'Circe, sans-serif',
        fontWeight: 700,
        cursor: 'pointer'
    },
    wrapCoin: {
        position: 'absolute', 
        top: '45%', 
        left: '40%',
        'animation-iteration-count': 'infinite',
        animationDuration: '2s',
        animationDirection: 'alternate',
        animationName: 'coinmobile'
    }
}))

export {
    useStyles,
    Amount,
    Coin
}